import {
  patientLoginActions,
  patientLogoutActions
} from '../../../../actions/user/patient/auth/login';

const initialState = {
  loading: false,
  error: null,
  isAuthenticated: false,
  patient: null,
  credentials: null
};

const patientAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    // LOGIN actions
    case patientLoginActions.LOGIN_PATIENT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null // Clear any previous errors on new request
      };
    case patientLoginActions.LOGIN_PATIENT.SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        patient: action.payload.patient,
        credentials: action.payload.credentials
      };
    case patientLoginActions.SET_PATIENT.CREDENTIALS:
      return {
        ...state,
        credentials: action.payload
      };
    case patientLoginActions.SET_PATIENT.AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload
      };
    case patientLoginActions.LOGIN_PATIENT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload // Store the error message from action.payload
      };
    case patientLoginActions.LOGIN_PATIENT.RESET:
      return {
        ...state,
        loading: false,
        error: null // Clear error on reset
      };

      // LOGOUT actions
    case patientLogoutActions.LOGOUT_PATIENT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null // Clear any previous errors on logout request
      };
    case patientLogoutActions.LOGOUT_PATIENT.SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        patient: null,
        credentials: null
      };
    case patientLogoutActions.LOGOUT_PATIENT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload // Store the error message from action.payload
      };
    case patientLogoutActions.LOGOUT_PATIENT.RESET:
      return {
        ...state,
        loading: false,
        error: null // Clear error on reset
      };
    default:
      return state;
  }
};
export default patientAuthReducer;
